export const API_EXTERNAL_ENDPOINT = 'user/is-logged'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/user/is-logged'
